<!-- #2984 modified by ngx-extended-pdf-viewer -->
<!-- PDF.js v5.6.205 uses #viewsManagerContent as the scrollable container -->
<div id="viewsManagerContent" tabindex="-1">
  <div id="thumbnailsView" (keydown)="onKeyDown($event)"></div>
  <!-- #3113 modified by ngx-extended-pdf-viewer - Add treeView class for proper outline/layers tree styling -->
  <div id="outlinesView" class="treeView hidden"></div>
  <div id="attachmentsView" class="hidden"></div>
  <div id="layersView" class="treeView hidden"></div>
  <!-- #3113 end of modification by ngx-extended-pdf-viewer -->
</div>
<!-- #2984 end of modification by ngx-extended-pdf-viewer -->

<!-- Updated to match PDF.js v5.6.205 thumbnail structure:
     div.thumbnail > div.thumbnailImageContainer > img
     Checkbox is a sibling of thumbnailImageContainer, added by pdf.js when enableSplitMerge is true.
     page-number attribute is set on both .thumbnail and .thumbnailImageContainer for page number badge. -->
<ng-template #defaultThumbnail>
  <div class="thumbnail pdf-viewer-template" page-number="PAGE_NUMBER">
    <div class="thumbnailImageContainer missingThumbnailImage" role="button" tabindex="-1" page-number="PAGE_NUMBER">
      <img class="thumbnailImage" />
    </div>
  </div>
</ng-template>
